var _linearGradient, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 317,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 317",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "3.951709%",
    x2: "75.897073%",
    y1: "26.993029%",
    y2: "52.919266%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m157.665785.00054936-157.66523564 157.66523564 48.80041204 48.800412 206.4667466-206.46564764z",
    fill: "#47c5fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m156.567183 145.396793-84.4184723 84.418472 48.9838973 49.71564 48.710317-48.710318 85.424893-85.423794z",
    fill: "#47c5fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m121.133047 279.531124 37.081545 37.081546h97.052567l-85.424893-85.791863z",
    fill: "#00569e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m71.5995742 230.364072 48.8015108-48.801511 49.440961 49.258575-48.709219 48.710318z",
    fill: "#00b5f8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m121.132827 279.531454 40.560069-13.459227 4.028979-31.130919z",
    fill: "url(#a)",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.f6de375f32cdf20a7574c624b074852d.svg";
export { ForwardRef as ReactComponent };